import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

const Row = ({ children, className, ...props }) => {
  const { classes, cx } = useStyles(styles);
  return (
    <div className={cx(classes.row, className)} {...props}>
      {children}
    </div>
  );
};

const styles = ({ spacing }) => ({
  row: {
    width: '100%',
    maxWidth: 780,
    paddingBottom: spacing(4),
    marginBottom: spacing(0),
    // borderBottom: `1px solid #cccc`,
    '&:last-child': {
      paddingBottom: spacing(0),
    },
  },
});

Row.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Row;
